import c from './table.module.scss';

export const Table = ({ children }) => {
  return (
    <table className={c.table} border={0}>
      {children}
    </table>
  );
};

export const TableHeader = ({ children }) => {
  return <div className={c.tableHeader}>{children}</div>;
};

export const TableRow = ({ children }) => {
  return <tr className={c.tableRow}>{children}</tr>;
};
export const TableCell = ({ children }) => {
  return <td className={c.tableCell}>{children}</td>;
};
